import { Mention } from "primereact/mention";
import React, {
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import EmojiPicker from "emoji-picker-react";
import LoginLoader from "../../Shared/Sidebar/LoginLoader";

const Commnent = ({
  reciveCommentData,
  sendCommentData,
  employeesList,
  commentType,
  loader,
}) => {
  const [feedText, setFeedText] = useState("");
  const [mentionedArr, setMentionedArr] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [multipleSuggestions, setMultipleSuggestions] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [isVisibleEmoji, setisVisibleEmoji] = useState(false);
  const pickerRef = useRef(null);
  const tagSuggestions = [
    "instagood",
    "photooftheday",
    "beautiful",
    "art",
    "photography",
    "happy",
    "picoftheday",
    "cute",
    "follow",
    "followme",
    "nature",
    "like4like",
    "travel",
    "instagram",
    "style",
    "repost",
    "summer",
    "instadaily",
    "selfie",
    "me",
    "friends",
    "fitness",
    "girl",
    "food",
    "fun",
    "beauty",
    "instalike",
    "smile",
    "family",
    "photo",
    "life",
    "likeforlike",
    "music",
    "ootd",
    "follow4follow",
    "makeup",
    "amazing",
    "igers",
    "nofilter",
    "dog",
    "model",
    "sunset",
    "beach",
  ];

  useEffect(() => {
    setEmployee(employeesList);
    if (reciveCommentData && commentType == 0) {
      setFeedText("");
    } else if (reciveCommentData && commentType == 2) {
      let NewSuggestion = reciveCommentData?.PostMentions?.map((emp) => ({
        MentionedName: emp?.FullName ?? emp?.MentionedName,
        MentionedId: emp?.Id,
        CommentId: emp?.ParentCommentId,
        MentionedUserId: emp?.MentionedUserId,
      }));
      setMentionedArr(NewSuggestion);
      setFeedText("");
    } else {
      setFeedText(reciveCommentData?.Comment ?? reciveCommentData?.Reaction);
    }
  }, [reciveCommentData, commentType, employeesList]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setisVisibleEmoji(false); // hide picker when clicked outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const getFeedText = (event) => {
    setFeedText(event.target.value);
  };
  const onSelectHandler = useCallback(
    (e) => {
      let selectedMention = {
        MentionedName: e.suggestion?.FullName,
        MentionedId: e.suggestion?.Id,
        // MentionedGuid: e.suggestion?.GUID,
        MentionedUserId: e.suggestion?.GUID,
        CommentId: 0,
      };
      setMentionedArr((prevSelectedData) => [
        ...prevSelectedData,
        selectedMention,
      ]);
    },
    [mentionedArr]
  );

  const onMultipleSearch = (event) => {
    const trigger = event.trigger;
    if (trigger === "@") {
      setTimeout(() => {
        const query = event.query;
        let suggestions;
        if (!query.trim().length) {
          suggestions = [...employee];
        } else {
          suggestions = employee?.filter((customer) => {
            return customer.FullName.toLowerCase().startsWith(
              query.toLowerCase()
            );
          });
        }
        setMultipleSuggestions(suggestions);
      }, 250);
    } else if (trigger === "#") {
      setTimeout(() => {
        const query = event.query;
        let suggestions;

        if (!query.trim().length) {
          suggestions = [...tagSuggestions];
        } else {
          suggestions = tagSuggestions.filter((tag) => {
            return tag.toLowerCase().startsWith(query.toLowerCase());
          });
        }
        setMultipleSuggestions(suggestions);
      }, 250);
    }
  };

  const multipleItemTemplate = (suggestion, options) => {
    const trigger = options.trigger;
    if (trigger === "@" && suggestion.FullName) {
      return itemTemplate(suggestion);
    } else if (trigger === "#" && !suggestion.FullName) {
      return <span>{suggestion}</span>;
    }
    return null;
  };

  const itemTemplate = (suggestion) => {
    const src = suggestion.ProfileImage;
    return (
      <div className="flex align-items-center">
        <img
          alt={suggestion.FullName || defaultImage}
          onError={handleImageError}
          src={src}
          th="32"
          style={{ maxWidth: "10%", height: "auto" }}
        />
        <span className="flex flex-column ml-2">{suggestion.FullName}</span>
      </div>
    );
  };

  let EmojiArr = [];
  const onEmojiClick = (emojiObject, feedId) => {
    let textId = document.getElementById(`feedtextarea2-${feedId}`);
    if (!textId) return;

    const start = textId.selectionStart;
    const end = textId.selectionEnd;

    EmojiArr.push(emojiObject.emoji);

    const netText =
      textId.value.slice(0, start) + EmojiArr[0] + textId.value.slice(end);

    textId.value = netText;

    const newCursorPosition = start + EmojiArr[0].length;
    textId.setSelectionRange(newCursorPosition, newCursorPosition);
    textId.focus();

    setFeedText(netText);
  };

  const FeedPostComment = (feedText) => {
    setisVisibleEmoji(false);
    setFeedText("");
    sendCommentData(reciveCommentData, mentionedArr, feedText, commentType);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      setFeedText("");
      FeedPostComment(feedText);
    }
  };

  return (
    <>
      <Mention
        value={feedText}
        onFocus={(e) => {
          getFeedText(e);
        }}
        inputId={`feedtextarea2-${commentType}`}
        onChange={(e) => {
          const trimmedValue = e.target.value.trimStart();
          if (trimmedValue !== " ") {
            getFeedText({ ...e, target: { ...e.target, value: trimmedValue } });
          }
        }}
        onSelect={onSelectHandler}
        trigger={["@", "#"]}
        suggestions={multipleSuggestions}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            const trimmedValue = e.target.value.trim();
            if (trimmedValue === "") {
              e.preventDefault()
              return;
            }
            handleKeyDown(e);
          }
        }}
        onSearch={onMultipleSearch}
        field={["FullName"]}
        itemTemplate={multipleItemTemplate}
        rows={2}
        cols={69}
        maxLength={500}
      />
      <div
        style={{
          textAlign: "right",
          fontSize: "12px",
          position: "absolute",
          right: "27px",
          bottom: "1px",
          color: feedText?.length >= 500 ? "red" : "#555",
        }}
      >
        {/* {feedText?.length || 0}/500 */}
      </div>
      <div className="icons" style={{ zIndex: 1 }}>
        <div className="inner-position-relative">
          <div>
            <svg
              onClick={() => setisVisibleEmoji(!isVisibleEmoji)}
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="currentColor"
              className="bi bi-emoji-smile"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5" />
            </svg>
          </div>
          {feedText?.length >= 1 ? (
            <div onClick={() => FeedPostComment(feedText)}>
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 16 16"
                height="13"
                width="13"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"></path>
              </svg>
            </div>
          ) : (
            ""
          )}
          {loader ? <LoginLoader /> : ""}
          {isVisibleEmoji && (
            <div ref={pickerRef} style={{ position: "absolute", zIndex: 1000 }}>
              <EmojiPicker
                onEmojiClick={(emojiObject) =>
                  onEmojiClick(emojiObject, commentType)
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Commnent;
